import {NgModule} from '@angular/core';
import {ActivatedRoute, RouterModule} from '@angular/router';

import {CoreCommonModule} from '@core/common.module';

import {FooterComponent} from 'app/layout/components/footer/footer.component';
import {ScrollTopComponent} from 'app/layout/components/footer/scroll-to-top/scroll-top.component';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [FooterComponent, ScrollTopComponent],
  imports: [RouterModule, CoreCommonModule, TranslateModule],
  exports: [FooterComponent]
})
export class FooterModule {
}
